import { AnyAction } from "@reduxjs/toolkit";
import {
    QUERY_EXECUTE_FAILURE,
    QUERY_EXECUTE_SAGA,
    QUERY_EXECUTE_SUCCESS,
    QUERY_RESET_RESULTS_SAGA,
    QUERY_RESET_SAGA,
} from "@/Redux/Query/QueryConstants";
import { RootStateOrAny } from "react-redux";

interface AppState {
    isExecuting: any;
    queryResults: any;
}

const initialState: AppState = {
    isExecuting: false,
    queryResults: [],
};

export default function QueryReducer(state = initialState, action: AnyAction) {
    switch (action.type) {
        case QUERY_EXECUTE_SAGA: {
            return {
                ...state,
                isExecuting: true,
            };
        }
        case QUERY_EXECUTE_SUCCESS: {
            if (Object.keys(action.data.queryResult).length > 0) {
                pushStateResults(state, action);
            }
            return {
                ...state,
                isExecuting: false,
                queryResults: state.queryResults,
            };
        }
        case QUERY_EXECUTE_FAILURE: {
            pushStateResults(state, action);
            return {
                ...state,
                isExecuting: false,
                queryResults: state.queryResults,
            };
        }
        case QUERY_RESET_SAGA:
            pushStateResults(state, action);
            return {
                ...state,
                isExecuting: false,
                queryResults: state.queryResults,
            };
        case QUERY_RESET_RESULTS_SAGA:
            const queryIndex = state.queryResults?.findIndex(
                (queryResult: any) => {
                    return (
                        queryResult?.result?.queryResult?.queryId ==
                        action.payload.queryId
                    );
                },
            );

            let newQueryResults = state!.queryResults;
            if (queryIndex != -1) {
                newQueryResults = state!.queryResults.map(
                    (queryResult: any, index: number) => {
                        if (index == queryIndex) {
                            return {
                                params: queryResult.params,
                                result: {
                                    queryResult: {
                                        queryId: action.payload.queryId,
                                        columns:
                                            queryResult.result.queryResult
                                                .columns,
                                        rows: [],
                                    },
                                },
                            };
                        }
                        return queryResult;
                    },
                );
            }
            return {
                ...state,
                queryResults: newQueryResults,
            };
        default:
            return state;
    }
}

export const pushStateResults = (state: RootStateOrAny, action: any) => {
    const oldResultIndex = state.queryResults.findIndex((result: any) => {
        return (
            result.result?.queryResult?.queryId ==
            action.data?.queryResult?.queryResult?.queryId
        );
    });
    if (oldResultIndex == -1)
        state.queryResults.push({
            result: action.data?.queryResult,
            params: action.data?.params,
        });
    else {
        state.queryResults[oldResultIndex] = {
            result: action.data?.queryResult,
            params: action.data?.params,
        };
    }
};

export const getState = (state: RootStateOrAny) => {
    if (typeof state.query === "object") {
        return state.query;
    }
    return state;
};

export const isExecuting = (state: RootStateOrAny) => {
    return getState(state).isExecuting;
};

export const selectAllQueryResults = (state: RootStateOrAny) => {
    return getState(state).queryResults;
};
